import { render, staticRenderFns } from "./BlockUsersList.vue?vue&type=template&id=aee2207e&scoped=true"
import script from "./BlockUsersList.vue?vue&type=script&lang=js"
export * from "./BlockUsersList.vue?vue&type=script&lang=js"
import style0 from "./BlockUsersList.vue?vue&type=style&index=0&id=aee2207e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee2207e",
  null
  
)

export default component.exports